<h1 mat-dialog-title>
  <ng-container i18n="Contest Details Modal|Contest Details modal title@@contest-details-modal-title">
    Contest
  </ng-container>
  <span *ngIf="contest">: {{contest.name}}</span>
</h1>
<div mat-dialog-content #dialogContent class="full-width details-content">
  <div *ngIf="contest">
    <div *ngIf="contest.description" class="description"
         [innerHTML]="sanitizer.bypassSecurityTrustHtml(contest.description)"></div>

    <div class="additional-info">
        <span class="text-disabled-color"
              i18n="Contest Enrol Modal|Contest Enrol period section title@@contest-enrol-modal-period-section-title">
          Period:
        </span>
      {{contest.startsAt | date: 'medium'}} - {{contest.endsAt | date: 'medium'}}
    </div>

    <div *ngIf="isContestFinished(contest)" class="certificate-holder">
      <app-link icon="verified"
                label="get certificate"
                [disabled]="certificateNotConfigured"
                i18n-label="Stats Dashboard|Exam Card get certificate title@@stats-dashboard-exam-card-get-certificate-title"
                (click)="requestCertificate()"></app-link>
      <mat-spinner *ngIf="certificateGetInProgress" diameter="20" color="primary"
                   class="progress"></mat-spinner>
      <a *ngIf="!certificateGetInProgress && certificateUrl" [href]="certificateUrl" target="_blank"
         class="progress">
        <mat-icon color="primary"
                  class="certificate-icon"
                  matTooltip="Certificate"
                  i18n-matTooltip="General|Contest certificate term@@general-contest-certificate-term">fact_check
        </mat-icon>
      </a>
    </div>

    <div *ngIf="contest.taskInfoUrl && isContestFinished(contest)" class="tasks-book-holder">
      <app-link icon="auto_stories"
                label="tasks book"
                i18n-label="Stats Dashboard|Exam Card tasks book title@@stats-dashboard-exam-card-tasks-book-title"
                [href]="contest.taskInfoUrl"
                [external]="true"></app-link>
    </div>
  </div>
</div>
<div mat-dialog-actions>
  <app-button [disabled]="inProgress"
              (clicked)="closeModal()"
              [secondary]="true"
              label="Close"
              i18n-label="General|Close action label@@general-close-action-label"></app-button>
</div>
